/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { Image, ScrollTracking } from '@ta-interaktiv/contentbricks'

// TODO Set the correct article ID here
const ARTICLE_ID = '16606080'
const ADDITIONAL_SHARES = 29
export function AppComponent() {
  const isMobile = window.innerWidth < 600
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} additionalShares={ADDITIONAL_SHARES} />
      <ThemeSwitch />

      {/* TODO Replace the following segment with your project cover */}
      <header className='ui vertical fitted segment'>
        <div className='ui container'>
          <h1 className='ui header' style={{ marginBottom: 0 }}>
            In diesen Gemeinden wohnen die Klimasünder
          </h1>
          <h2 className='ui header' style={{ marginTop: 0 }}>
            <div className='small sub header'>
              Eine Datenanalyse zeigt erstmals, in welchen Schweizer Gemeinden
              besonders viele Autos mit hohem CO₂-Ausstoss unterwegs sind. Wie
              sieht es in Ihrer Gemeinde aus?
            </div>
          </h2>
          <p className='ta author'>
            <strong>Dominik Balmer, Fanny Giroud, Mathias Born</strong>
          </p>
        </div>
      </header>

      {/* TODO And probably remove the following segment and replace it with
       your own content */}
      <div className='ui vertical segment'>
        <div className='ui text container' style={{ marginTop: '0rem' }}>
          <p>
            Die Autofahrer und Autofahrerinnen tragen einen wesentlichen Teil
            zur schlechten Klimabilanz der Schweiz bei. So stammt laut dem
            Bundesamt für Umwelt rund ein Drittel der gesamten Emissionen von
            Kohlenstoffdioxid (CO₂) in der Schweiz aus dem Verkehr. Und davon
            wiederum kommen drei Viertel von den Personenwagen. CO₂ ist ein
            Treibhausgas, das den Klimawandel beschleunigt.
          </p>
          <p>
            Die Politik versucht, Gegensteuer zu geben – allerdings ohne grossen
            Erfolg, wie ein neuer Bericht des Bundesamts für Energie (BFE)
            zeigt: Zwar sind die Autoimporteure seit 2012 verpflichtet, die
            Emissionen von neuen Personenwagen auf den Zielwert von
            durchschnittlich 130 Gramm CO₂ pro Kilometer zu beschränken. Seit
            2015 ist dieser Wert verbindlich. Er wurde aber bislang immer
            verfehlt. Können die Importeure den Wert nicht einhalten, müssen sie
            Strafzahlungen leisten – 2018 waren es rund 32 Millionen Franken.
          </p>
          <p>
            Klar ist, dass diese Strafzahlungen künftig noch viel höher
            ausfallen werden. Denn seit diesem Jahr gilt ein neuer Zielwert von
            95 Gramm CO₂ pro Kilometer. Kommt hinzu, dass die CO₂-Werte der
            Neuwagen zuletzt sogar gestiegen sind.
          </p>
          <p>
            Für die Gesamtbilanz ist allerdings vor allem entscheidend, wie viel
            CO₂ die bestehenden Autos ausstossen. Eine Datenanalyse geht jetzt
            erstmals dieser Frage nach – und zeigt, in welchen Gemeinden die
            Autofahrerinnen und -fahrer besonders umweltschädigend unterwegs
            sind. Basis der Auswertung ist ein Datensatz des Bundesamts für
            Strassen (Astra) mit rund 4,6 Millionen Personenwagen.
          </p>
        </div>

        <ScrollTracking label='content25' />

        <div className='ui text container' style={{ marginTop: '4rem' }}>
          <h3 className='ui infographic header small'>
            Die grossen sechs Städte
          </h3>
          {/* <p className='sectionIntro'>
            Die Fahrzeuge in den sechs Grossstädten haben einen Anteil von:
          </p> */}
          {/* <div className='barBylineTop'>4.6 Mio.</div> */}
          <div className='barWrapper'>
            <div className='bar' style={{ width: 8.0 + '%' }} />
          </div>
          <div className='barByline'>
            <div className='barBylineLeft'>8% aller Autos in der Schweiz</div>
            <div className='barBylineRight'>4,6 Mio.</div>
          </div>
          <p className='readerExample'>
            <span className='black'>Lesebeispiel:</span> Der durchschnittliche
            CO₂-Ausstoss aller Autos, die in der Stadt Basel gemeldet sind,
            beträgt rund 163 Gramm CO₂ pro Kilometer. Das ist knapp über dem
            Schweizer Schnitt von 160 Gramm CO₂ pro Kilometer.
          </p>

          <div className='legendWrapper'>
            <div className='legendItem'>
              <div className='squareOne' />
              <div className='linechartText'>Top-Grossstädte</div>
            </div>
            <div className='legendItem'>
              <div className='squareTwo' />
              <div className='linechartText'>Flop-Grossstädte</div>
            </div>
          </div>
        </div>
        <div className='ui container'>
          <Image
            file={[
              require('../../images/mobile-grossstaedte.png'),
              require('../../images/desktop-grossstaedte.png')
            ]}
            source='Kartenmaterial: Bundesamt für Statistik, GEOSTAT'
          />
        </div>

        <div className='ui text container'>
          <div className='iframeContainer'>
            <AutofitIFrame
              title='Liste CO₂-Ausstoss der Autos in Grossstädten'
              aria-label='Interactive line chart'
              src='//datawrapper.dwcdn.net/tXDBb/4/'
              width='581'
            />
          </div>
          <p>
            Städter sehen sich gemeinhin als umweltfreundlich. Allerdings gilt
            dies nicht für alle städtischen Autofahrer, wie die Datenanalyse
            belegt. So beträgt beispielsweise der durchschnittliche CO₂-Ausstoss
            der Autos in der Stadt Basel rund 163 Gramm pro Kilometer. Damit
            liegt die Stadt sogar über dem schweizerischen Schnitt von rund 160
            Gramm. Ebenfalls darüber liegt die Stadt Genf.
          </p>
          <p>
            Den tiefsten Wert der sechs grössten Schweizer Städte weist Lausanne
            auf: nicht einmal 150 Gramm CO₂ pro Kilometer. Die Lausanner sind
            bekannt für ihre besonders kritische Haltung gegenüber Offroadern,
            die in der Regel besonders viel Benzin verbrauchen. So hatten linke
            Kreise vor kurzem eine Initiative lanciert, um Geländewagen und
            sogenannte Super Utility Vehicles (SUV) aus der Stadt zu verbannen.
          </p>
          <p>
            Doch selbst fürs vorbildliche Lausanne gilt: Der durchschnittliche
            CO₂-Wert aller Autos liegt immer noch deutlich über den Werten, wie
            sie kleinere Gemeinden im Tessin oder in der Waadt aufweisen.
          </p>
        </div>
        <div className='ui text container' style={{ marginTop: '4rem' }}>
          <h3 className='ui infographic header small'>Die Berggemeinden</h3>
          <div className='barWrapper'>
            <div className='bar' style={{ width: 26 + '%' }} />
          </div>
          <div className='barByline'>
            <div className='barBylineLeft'>26% aller Autos in der Schweiz</div>
            <div className='barBylineRight'>4,6 Mio.</div>
          </div>
          <p className='readerExample'>
            <span className='black'>Lesebeispiel:</span> Der durchschnittliche
            CO₂-Ausstoss aller Autos, die in der Gemeinde Riemenstalden gemeldet
            sind, beträgt rund 205 Gramm CO₂ pro Kilometer. Der Durchschnitt
            aller Autos in der Schweiz beträgt 160 Gramm CO₂ pro Kilometer.
          </p>

          <div className='legendWrapper'>
            <div className='legendItem'>
              <div className='squareOne' />
              <div className='linechartText'>Top-Gemeinden</div>
            </div>
            <div className='legendItem'>
              <div className='squareTwo' />
              <div className='linechartText'>Flop-Gemeinden</div>
            </div>
          </div>
        </div>
        <div className='ui container'>
          <Image
            file={[
              require('../../images/mobile-berggemeinde.png'),
              require('../../images/desktop-berggemeinde.png')
            ]}
            source='Kartenmaterial: Bundesamt für Statistik, GEOSTAT'
          />
        </div>
        <div className='ui text container'>
          <div className='iframeContainer'>
            <AutofitIFrame
              title='Liste CO₂-Ausstoss der Autos in Berggemeinden'
              aria-label='Interactive line chart'
              src='//datawrapper.dwcdn.net/inRrf/8/'
              // height={isMobile ? '440' : '340'}
              width='581'
            />
          </div>
          <p>
            Riemenstalden hält einen unrühmlichen Rekord. In der bergigen
            Gemeinde im Kanton Schwyz fahren die Einwohner besonders
            klimaschädliche Autos. Gemäss der Datenanalyse gibt es in
            Riemenstalden per Ende Januar 2020 rund 40 immatrikulierte Autos –
            bei nicht einmal 100 Einwohnerinnen und Einwohnern. Und sehr viele
            dieser Autos haben einen Allradantrieb. Die zahlreichen Offroader
            sind denn auch alles andere als klimafreundlich. Pro Auto in der
            Berggemeinde beträgt der durchschnittliche CO₂-Ausstoss 205 Gramm
            pro Kilometer. Dieser Wert entspricht laut Experten einem
            durchschnittlichen Benzinverbrauch von 8,9 Litern auf 100 Kilometer.
          </p>
          <p>
            Trotz Rekordwerten – Gemeindepräsident Martin Gisler stört sich
            nicht daran. «Solange die Leute immer noch um die Welt fliegen, habe
            ich keine Probleme damit», sagt er. In Riemenstalden sei man eben
            aufs Auto angewiesen. «Wir haben kaum öffentlichen Verkehr.» Einzig
            am Morgen und am Nachmittag fährt ein Postauto in die Gemeinde.
            Gisler selber besitzt einen VW als Familienauto und einen Jeep für
            Viehtransporte. Und er betont: «Wir fahren mit unseren Autos nur
            sehr wenige Kilometer im Jahr.» Er selber mache zudem nie Ferien.
            Das müsse auch berücksichtigt werden. Zudem seien Elektroautos gar
            nicht so umweltfreundlich, wie es immer heisse – dies gelte gerade
            für die Herstellung und Entsorgung der Batterien.
          </p>
          <p>
            Allerdings sehen dies die Autoexperten vom Verkehrs-Club der Schweiz
            (VCS) anders. Gerade von Elektroautos erhoffen sie sich einiges. «In
            absehbarer Zeit werden auch immer mehr Elektromodelle angeboten, die
            genügend leistungsfähig für die Schweizer Bergregionen sind», sagt
            Anette Michel, VCS-Projektleiterin Auto-Umweltliste. Gerade in
            Bergregionen dürften Elektroautos zusätzlich attraktiv werden, «weil
            beim Herunterfahren Bremsenergie zurückgewonnen werden kann».
          </p>
          <p>
            Die Analyse zeigt aber auch, dass es durchaus Berggemeinden gibt,
            die weniger klimaschädliche Autos haben – beispielsweise im Tessin.
          </p>
        </div>
        <ScrollTracking label='content50' />
        <div className='ui text container' style={{ marginTop: '4rem' }}>
          <h3 className='ui infographic header small'>
            Die städtischen Gemeinden
          </h3>
          <div className='barWrapper'>
            <div className='bar' style={{ width: 41.6 + '%' }} />
          </div>
          <div className='barByline'>
            <div className='barBylineLeft'>
              41,6% aller Autos in der Schweiz
            </div>
            <div className='barBylineRight'>4,6 Mio.</div>
          </div>
          <p className='readerExample'>
            <span className='black'>Lesebeispiel:</span> Der durchschnittliche
            CO₂-Ausstoss aller Autos, die in der städtisch geprägten Gemeinde
            Wollerau gemeldet sind, beträgt rund 173 Gramm CO₂ pro Kilometer.
            Das ist über dem Schweizer Schnitt von 160 Gramm CO₂ pro Kilometer.
          </p>
          <div className='legendWrapper'>
            <div className='legendItem'>
              <div className='squareOne' />
              <div className='linechartText'>Top-Gemeinden</div>
            </div>
            <div className='legendItem'>
              <div className='squareTwo' />
              <div className='linechartText'>Flop-Gemeinden</div>
            </div>
          </div>
        </div>
        <div className='ui container'>
          <Image
            file={[
              require('../../images/mobile-staedte.png'),
              require('../../images/desktop-staedte.png')
            ]}
            source='Kartenmaterial: Bundesamt für Statistik, GEOSTAT'
          />
        </div>
        <div className='ui text container'>
          <div className='iframeContainer'>
            <AutofitIFrame
              title='Liste CO₂-Ausstoss der Autos in städtischen Gemeinden'
              aria-label='Interactive line chart'
              src='//datawrapper.dwcdn.net/FL5Sy/5/'
              // height={isMobile ? '440' : '340'}
              width='581'
            />
          </div>
          <p>
            In der Kategorie der kleineren Städte und den städtisch geprägten
            Gemeinden bestätigen sich viele Klischees. Die Analyse zeigt
            deutlich: Die reichen Gemeinden insbesondere in der Deutschschweiz
            mit guter Lage an den Seen weisen hohe Werte auf. In der
            Spitzengruppe vertreten sind auch die Zürcher Goldküstengemeinden.
            Ganz zuoberst steht jedoch das Steuerparadies Wollerau im Kanton
            Schwyz. Überraschend dabei: Wollerau besitzt offiziell das Label
            Energiestadt vom Bundesamt für Energie – und stellt diesen Umstand
            auf der Website auch entsprechend prominent dar. Mit dem Label
            zeichnet das Bundesamt für Energie in der Schweiz Gemeinden aus,
            «die ein Qualitätsmanagement für die Umsetzung ihrer Energie und
            Umweltpolitik eingeleitet haben». Wollerau zum Beispiel verfügt laut
            Angaben auf der Website über eine «sorgfältig erarbeitete
            Energiestrategie 2020». Der Autoverkehr scheint dabei allerdings
            keine Rolle zu spielen, wie der Spitzenwert in dieser Kategorie
            zeigt.
          </p>
          <p>
            Wie passt das zusammen? Wolleraus Gemeindeschreiber Andreas
            Meyerhans geht in seiner Antwort nicht näher auf das
            Energiestadt-Label ein. Er sagt bloss: «Wir nehmen das Resultat zur
            Kenntnis. Und wir stellen fest, dass die Einwohner unserer Gemeinde
            auch Autos kaufen, die einen etwas höheren CO₂-Ausstoss haben.
            Allerdings können wir als Gemeinde keinen Einfluss darauf nehmen.»
          </p>
          <p>
            Letztlich dürften die CO₂-Werte einzelner Gemeinden auch vom
            Wohlstand beeinflusst sein. Dieser scheine «ein entscheidendes
            Kriterium» bei der Modellwahl zu sein, sagt VCS-Projektleiterin
            Anette Michel. Dies zeige auch die Neuwagen-Statistik. Zug weise
            dabei die höchsten CO₂-Emissionen auf; die Werte von Obwalden und
            dem Tessin seien am tiefsten. Auch Micaël Tille, Dozent für
            Transportwesen und Infrastruktur an der EPFL Lausanne, sagt: «Die
            Schweiz ist ein reiches Land. Hier kaufen die Leute in der Regel
            mehr mächtige und schwere Autos als in anderen Ländern. Wenn man
            deswegen einen Umwelt-Straf-Zuschlag zahlen muss, stört das
            niemanden.»
          </p>
        </div>
        <div className='ui text container' style={{ marginTop: '4rem' }}>
          <h3 className='ui infographic header small'>Die Landgemeinden</h3>
          <div className='barWrapper'>
            <div className='bar' style={{ width: 9.9 + '%' }} />
          </div>
          <div className='barByline'>
            <div className='barBylineLeft'>9,9% aller Autos in der Schweiz</div>
            <div className='barBylineRight'>4,6 Mio.</div>
          </div>
          <p className='readerExample'>
            <span className='black'>Lesebeispiel:</span> Der durchschnittliche
            CO₂-Ausstoss aller Autos, die in der ländlich geprägten Gemeinde
            Kilchberg BL gemeldet sind, beträgt rund 183 Gramm CO₂ pro
            Kilometer. Das ist über dem Schweizer Schnitt von 160 Gramm CO₂ pro
            Kilometer.
          </p>
          <div className='legendWrapper'>
            <div className='legendItem'>
              <div className='squareOne' />
              <div className='linechartText'>Top-Gemeinden</div>
            </div>
            <div className='legendItem'>
              <div className='squareTwo' />
              <div className='linechartText'>Flop-Gemeinden</div>
            </div>
          </div>
        </div>
        <div className='ui container'>
          <Image
            file={[
              require('../../images/mobile-land.png'),
              require('../../images/desktop-land.png')
            ]}
            source='Kartenmaterial: Bundesamt für Statistik, GEOSTAT'
          />
        </div>
        <div className='ui text container'>
          <div className='iframeContainer'>
            <AutofitIFrame
              title='Liste CO₂-Ausstoss der Autos in Landgemeinden'
              aria-label='Interactive line chart'
              src='//datawrapper.dwcdn.net/Xl4uT/5/'
              // height={isMobile ? '440' : '340'}
              width='581'
            />
          </div>
          <p>
            Bemerkenswert ist die Verteilung in den Gemeinden, die zu den
            ländlich geprägten gehören. An der Spitze stehen gleich drei
            Gemeinden aus dem Kanton Basel-Landschaft: Kilchberg, Häfelfingen
            und Liesberg. Warum das so ist, wissen selbst die basel-ländischen
            Behörden nicht. Bei der zuständigen Motorfahrzeugkontrolle heisst es
            bloss, man habe «keine Erklärung» für den geschilderten Sachverhalt.
          </p>
          <p>
            Die tiefsten Werte in derselben Kategorie weisen insbesondere
            zahlreiche Gemeinden aus dem Kanton Waadt auf. Diese Verteilung auf
            Gemeindeebene bildet sich auch bei den kantonalen
            Durchschnittswerten ab. Der Kanton Waadt hat gemeinsam mit dem
            Tessin und weiteren Kantonen aus der Romandie die tiefsten
            durchschnittlichen CO₂-Werte.
          </p>
          <p>
            Warum diese Kantone tiefe Werte haben, ist auch für Experten nicht
            restlos geklärt. Eine mögliche Erklärung sind Prämien, die einzelne
            Kantone für den Kauf von Elektroautos gewähren – der Kanton Tessin
            beispielsweise kennt ein solches Modell.
          </p>
          <p>
            Bei der Kategorie der Landgemeinden handelt es sich durchwegs um
            solche, die nicht der offiziellen Kategorie der Berggemeinden
            angehören. Das Argument, wegen der Topografie einen Offroader zu
            fahren, gilt daher nicht. Anette Michel, VCS-Projektleiterin
            Auto-Umweltliste, sagt es so: «Die grosse Mehrheit der Schweizer
            Bevölkerung benötigt keinen Allradantrieb und keinen grossen SUV für
            den täglichen Gebrauch. Viele Autos sind ganz klar zu gross, zu
            schwer und stossen zu viel CO₂ aus - europaweit am meisten.»
          </p>
        </div>
        <ScrollTracking label='content75' />
        <div className='ui text container' style={{ marginTop: '4rem' }}>
          <h3 className='ui infographic header small'>
            Die Gemeinden zwischen Stadt und Land
          </h3>
          <div className='barWrapper'>
            <div className='bar' style={{ width: 14.6 + '%' }} />
          </div>
          <div className='barByline'>
            <div className='barBylineLeft'>
              14,6% aller Autos in der Schweiz
            </div>
            <div className='barBylineRight'>4,6 Mio.</div>
          </div>
          <p className='readerExample'>
            <span className='black'>Lesebeispiel:</span> Der durchschnittliche
            CO₂-Ausstoss aller Autos, die in der Gemeinde Dittingen BL gemeldet
            sind, beträgt rund 174 Gramm CO₂ pro Kilometer. Das ist über dem
            Schweizer Schnitt von 160 Gramm CO₂ pro Kilometer.
          </p>

          {/* <h4 className='titleGraphic'>
            Die Gemeinden zwischen Stadt und Land
          </h4> */}
          <div className='legendWrapper'>
            <div className='legendItem'>
              <div className='squareOne' />
              <div className='linechartText'>Top-Gemeinden</div>
            </div>
            <div className='legendItem'>
              <div className='squareTwo' />
              <div className='linechartText'>Flop-Gemeinden</div>
            </div>
          </div>
        </div>
        <div className='ui container'>
          <Image
            file={[
              require('../../images/mobile-intermediaer.png'),
              require('../../images/desktop-intermediaer.png')
            ]}
            source='Kartenmaterial: Bundesamt für Statistik, GEOSTAT'
          />
        </div>
        <div className='ui text container'>
          <div className='iframeContainer'>
            <AutofitIFrame
              title='Liste CO₂-Ausstoss der Autos in Agglomerationen'
              aria-label='Interactive line chart'
              src='//datawrapper.dwcdn.net/RRKjX/4/'
              // height={isMobile ? '440' : '340'}
              width='581'
            />
          </div>
          <p>
            Abzüglich der Berggebiete gehören in der Schweiz rund 400 Gemeinden
            zur Kategorie «intermediär» – dazu gehören Gemeinden, die sowohl
            ländlich als auch städtisch geprägt sind. Die Verteilung in dieser
            Kategorie zeigt ein ähnliches Bild wie bei den Landgemeinden. Mit
            hohen Werten an der Spitze stehen Gemeinden aus dem Kanton
            Baselland. Mit tiefen Werten zeichnen sich insbesondere Orte in der
            Romandie aus.
          </p>
          <p>
            Ein Sonderfall stellt Dielsdorf ZH dar. Die Gemeinde in der Nähe des
            Zürcher Flughafens weist atypisch tiefe CO₂-Werte auf – über alle
            Autos hinweg sind es im Schnitt nur gerade rund 145 Gramm CO₂ pro
            Kilometer. Gleichzeitig ist in Dielsdorf die Quote der Elektroautos
            sehr hoch, was natürlich die CO₂-Werte auch beeinflusst – nur gerade
            die autofreien Tourismusdestinationen Zermatt und Saas-Fee stehen
            diesbezüglich besser da.
          </p>
          <p>
            Sandro Kälin, Sprecher von BMW Schweiz, bestätigt denn auch, dass
            «alle Fahrzeuge aus dem Fuhrpark der BMW Group Switzerland auf das
            Unternehmen mit Sitz in Dielsdorf ZH zugelassen werden. Der Fuhrpark
            befindet sich ebenfalls an diesem Standort.»
          </p>
          <p>
            Weiter will sich der Sprecher nicht mehr äussern. Die Datenanalyse
            zeigt aber, dass rund ein Drittel aller Autos aus dem Hause BMW
            stammen.
          </p>
        </div>
      </div>

      {/* TODO Add your credits in this component */}
      <Footer
        additionalShares={ADDITIONAL_SHARES}
        articleId={ARTICLE_ID}
        credits={[
          [
            'Konzept, Recherche und Text',
            'Dominik Balmer, Mathias Born und Fanny Giroud'
          ],
          ['Digitale Umsetzung', 'Patrick Vögeli']
        ]}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
      >
        <div className='ui vertical grey segment' id='methodik'>
          <div
            className='ui text container methodik'
            style={{ position: 'relative' }}
          >
            <div className='innerWrapperMethodik'>
              <h4>Methodik</h4>
              <p>
                Das Bundesamt für Strassen (Astra) verfügt über einen Datensatz
                mit allen 4,6 Millionen in der Schweiz registrierten
                Personenwagen. Diese Daten wurden für die vorliegende Analyse
                ausgewertet. Berücksichtigt sind alle Autos, die auf eine
                Schweizer Adresse eingelöst worden sind. Die Datenbank wurde im
                Januar 2020 abgerufen. Weil aber nicht alle Gemeinden auf dem
                neuesten Stand sind, wurde für die Auswertung mit dem
                Gemeindestand von 2018 gerechnet. Der in den Daten hinterlegte
                Wert in Gramm CO₂ pro Kilometer basiert gemäss dem Astra auf
                einer einheitlichen Grundlage. Und ist damit auch vergleichbar.
                Eine Ausnahme sind rund 400 Autos, deren Werte nach einer neuen
                Methode erfasst wurden. Dabei handelt es sich durchwegs um
                Autos, die im laufenden Jahr in Verkehr gesetzt wurden. Der
                Einfluss dieser Autos auf den Mittelwert ist aber so oder so
                vernachlässigbar. Gleichzeitig kann es sein, dass bei älteren
                und importierten Fahrzeugen teilweise keine CO₂-Werte hinterlegt
                sind. Diese wurden in der Auswertung nicht berücksichtigt. Die
                Kategorisierungen zur Raumgliederung wurden vom Bundesamt für
                Statistik übernommen. Weitere Details zur Datenaufbereitung und
                -auswertung können unter{' '}
                <a
                  href='https://www.github.com/tamedia-ddj/'
                  style={{ whiteSpace: 'nowrap' }}
                >
                  <i className='icon small external alternate' />
                  github.com/tamedia-ddj/
                </a>{' '}
                nachgelesen werden.
              </p>
            </div>
          </div>
        </div>
      </Footer>
    </div>
  )
}
